<template>
  <div v-if="adItem && adItem.content">
    <iframe
      ref="youtubeIframe"
      id="youtube-iframe"
      class="ad-design"
      :src="youtubeUrl"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  data() {
    return {
      settings: {}
    }
  },
  props: {
    adItem: {
      type: Object,
      default: null
    },
    playAd: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    'playAd': function (value) {
      if (value) {
        this.play()
      } else {
        this.pause()
      }
    }
  }
})
export default class Youtube extends Vue {
  get youtubeUrl () {
    if (!this.adItem || !this.adItem.content) {
      return ''
    }

    let url = `https://www.youtube.com/embed/${this.adItem.content}?controls=1&showinfo=0&rel=0&modestbranding=1`

    if (this.settings?.autoplay === true) {
      url += '&autoplay=1&mute=1'
    }

    if (this.settings?.loop === true) {
      url += `&loop=1`
    }

    return url
  }

  mounted () {
    this.updateSetting()

    if (this.playAd) {
      this.play()
    }
  }

  updateSetting () {
    if(!this.adItem || !this.adItem.data) {
      return
    }

    try {
      this.settings = JSON.parse(this.adItem.data).settings || {}
    } catch (e) {
      this.settings = {}
    }
  }

  play () {
    //code
  }

  pause () {
    //code
  }

  stop() {
    const iframe = this.$refs.youtubeIframe;
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*')
    }
  }

  beforeDestroy () {
    this.stop()
    this.cleanupIframe()
  }

  cleanupIframe () {
    const iframe = this.$refs.youtubeIframe
    if (iframe) {
      iframe.src = ''
      iframe.remove()
    }
  }
}
</script>
